import React from 'react'
import HowStartpageWorks from '../how-startpage-works'

const HowStartpageWorksEs = () => {
    return <HowStartpageWorks languageCode="es" />
}

export default HowStartpageWorksEs
